var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complaint-success"},[_c('img',{staticClass:"complaint-success-icon",attrs:{"src":require("../../assets/img/complaint_success.png"),"alt":""}}),_c('p',{staticClass:"complaint-success-main"},[_vm._v("提交成功")]),_c('p',{staticClass:"complaint-success-sub"},[_vm._v("您反馈的问题我们已收到，请耐心等待处理结果")])])
}]

export { render, staticRenderFns }